module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "group-manage"
    }
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "col",
    on: {
      "click": _vm.onCreateProSet
    }
  }, [_vm._v("New Collection")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('ul', {
    staticClass: "col"
  }, _vm._l((_vm.prosets), function(proset) {
    return _c('li', {
      staticClass: "grid grid-noGutter"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('router-link', {
      attrs: {
        "to": ("/manage/group/" + (proset.uid) + "/")
      }
    }, [_vm._v(_vm._s(proset.name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [_c('div', {
      staticClass: "grid grid-noGutter"
    }, [_c('div', {
      staticClass: "col",
      attrs: {
        "title": "Toggle Hidden"
      }
    }, [_c('i', {
      staticClass: "fa btn",
      class: proset.hidden ? 'fa-eye-slash' : 'fa-eye',
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.onToggleProSetHidden(proset)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col",
      attrs: {
        "title": "Remove"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o btn",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.onRemoveProSet(proset)
        }
      }
    })])])])])
  }))])]), _vm._v(" "), (_vm.current_proset !== null) ? _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_proset.name),
      expression: "current_proset.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.current_proset.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.current_proset.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_proset.metadata.deadline),
      expression: "current_proset.metadata.deadline"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Deadline (1984/01/01+0800)"
    },
    domProps: {
      "value": (_vm.current_proset.metadata.deadline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.current_proset.metadata.deadline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_proset.metadata.category),
      expression: "current_proset.metadata.category"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.current_proset.metadata.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Universe")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Algo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("CLang")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("PyLang")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, [_c('button', {
    on: {
      "click": _vm.onApplyProSet
    }
  }, [_vm._v("Apply")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('button', {
    on: {
      "click": _vm.onShowAddProItem
    }
  }, [_vm._v("Add Problem")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_add_proitem),
      expression: "show_add_proitem"
    }],
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_problem),
      expression: "selected_problem"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected_problem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.available_problems), function(problem) {
    return _c('option', {
      domProps: {
        "value": problem
      }
    }, [_vm._v(_vm._s(((problem.uid) + " - " + (problem.name))))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_deadline),
      expression: "selected_deadline"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Deadline (1984/01/01+0800)"
    },
    domProps: {
      "value": (_vm.selected_deadline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected_deadline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_section),
      expression: "selected_section"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Section"
    },
    domProps: {
      "value": (_vm.selected_section)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected_section = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, [_c('button', {
    on: {
      "click": _vm.onAddProItem
    }
  }, [_vm._v("Add")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.show_add_proitem = false
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.current_proitems), function(proitem) {
    return _c('tr', {
      staticClass: "grid"
    }, [_c('td', {
      staticClass: "col"
    }, [_c('router-link', {
      attrs: {
        "to": ("/problem/" + (proitem.problem.uid) + "/")
      }
    }, [_vm._v(_vm._s(proitem.problem.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "col-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proitem.deadline),
        expression: "proitem.deadline"
      }],
      attrs: {
        "type": "text",
        "placeholder": "No Deadline"
      },
      domProps: {
        "value": (proitem.deadline)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          proitem.deadline = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proitem.metadata.section),
        expression: "proitem.metadata.section"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Section"
      },
      domProps: {
        "value": (proitem.metadata.section)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          proitem.metadata.section = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-2"
    }, [_c('div', {
      staticClass: "grid grid-noGutter"
    }, [_c('div', {
      staticClass: "col",
      attrs: {
        "title": "Apply"
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o btn",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.onApplyProItem(proitem)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col",
      attrs: {
        "title": "Toggle Hidden"
      }
    }, [_c('i', {
      staticClass: "fa btn",
      class: proitem.hidden ? 'fa-eye-slash' : 'fa-eye',
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.onToggleProItemHidden(proitem)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col",
      attrs: {
        "title": "Remove"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o btn",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.onRemoveProItem(proitem)
        }
      }
    })])])])])
  })], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "grid"
  }, [_c('th', {
    staticClass: "col"
  }, [_vm._v("Problem")]), _vm._v(" "), _c('th', {
    staticClass: "col-3"
  }, [_vm._v("Deadline")]), _vm._v(" "), _c('th', {
    staticClass: "col-2"
  }, [_vm._v("Section")]), _vm._v(" "), _c('th', {
    staticClass: "col-2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c41e16b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/GroupManage.vue
// module id = 592
// module chunks = 0